import BasicSlider from "../swiper/basicSlider";

export default class OpinionSliderSection {
    constructor(el) {
        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;
        this.root = el;
        this.slider = this.root.querySelector('[data-swiper-slider]');

        return true;
    }

    init() {
        if (!this.slider) return;
        new BasicSlider(this.slider);
    }
}